module.exports = __webpack_public_path__ + "static/media/danholbrook.08f30104.JPG";